import { GRADES } from "@/lib/taxonomy";

export interface MarketingNavLink {
  href: string;
  label: string;
}

/** Tài liệu theo từng khối lớp (dropdown desktop / mục gập mobile). */
export const gradeNav: MarketingNavLink[] = GRADES.map((g) => ({
  href: `/kho-tai-lieu/${g}`,
  label: `Tài liệu Lớp ${g}`,
}));

export const gradeNavLabel = "Kho tài liệu theo khối lớp";

/** Các mục điều hướng phẳng, dùng chung cho header desktop và drawer mobile. */
export const marketingNav: MarketingNavLink[] = [
  { href: "/kho-tai-nguyen", label: "Kho tài nguyên" },
  { href: "/ai-ho-tro", label: "AI hỗ trợ" },
  { href: "/kho-game", label: "Kho game tương tác" },
];
